var _toConsumableArray = require("/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/helpers/defineProperty", "@babel/runtime/helpers/objectWithoutProperties"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/helpers/defineProperty"), require("@babel/runtime/helpers/objectWithoutProperties"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a.defineProperty, a.objectWithoutProperties), a.cluster = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c) {
  "use strict";

  var f = require("@babel/runtime/helpers/interopRequireDefault");

  function d(a, b) {
    var c = Object.keys(a);

    if (Object.getOwnPropertySymbols) {
      var d = Object.getOwnPropertySymbols(a);
      b && (d = d.filter(function (b) {
        return Object.getOwnPropertyDescriptor(a, b).enumerable;
      })), c.push.apply(c, d);
    }

    return c;
  }

  function e(a) {
    for (var c, e = 1; e < arguments.length; e++) {
      c = null == arguments[e] ? {} : arguments[e], e % 2 ? d(c, !0).forEach(function (d) {
        (0, b.default)(a, d, c[d]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(c)) : d(c).forEach(function (b) {
        Object.defineProperty(a, b, Object.getOwnPropertyDescriptor(c, b));
      });
    }

    return a;
  }

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.getClusteredFeatures = a.updateCluster = a.createClusterLayers = a.getPaintExpression = a.PREFIXES = a.PREFIX_COUNT = a.PREFIX_UNCLUSTERED = a.PREFIX_SOURCE = void 0, b = f(b), c = f(c);
  var g = "cluster-source";
  a.PREFIX_SOURCE = g;
  var h = "unclustered";
  a.PREFIX_UNCLUSTERED = h;
  var i = "count";
  a.PREFIX_COUNT = i;
  a.PREFIXES = [h, i];

  var j = function j(a, b) {
    return ["case"].concat(_toConsumableArray([].concat(_toConsumableArray(a), [null]).reduce(function (a, c, d) {
      return [].concat(_toConsumableArray(a), _toConsumableArray(c ? [["<", ["get", "point_count"], c], b[d]] : [b[d]]));
    }, [])));
  };

  a.getPaintExpression = j;

  var k = function k(_ref) {
    var a = _ref.map,
        b = _ref.layer,
        d = _ref.radius,
        _ref$minzoom = _ref.minzoom,
        k = _ref$minzoom === void 0 ? 0 : _ref$minzoom,
        _ref$maxzoom = _ref.maxzoom,
        l = _ref$maxzoom === void 0 ? 24 : _ref$maxzoom,
        f = _ref.index;
    var m = b.id,
        n = b.source,
        o = b["source-layer"],
        p = b.cluster,
        q = p.maxZoom,
        r = void 0 === q ? Math.floor(a.getMaxZoom()) + 1 : q,
        s = p.steps,
        t = p.sizes,
        u = p.colors,
        v = p.font,
        w = void 0 === v ? {} : v,
        x = w.family,
        y = void 0 === x ? ["DIN Offc Pro Medium", "Arial Unicode MS Bold"] : x,
        z = w.color,
        A = void 0 === z ? "#000000" : z,
        B = p.border,
        C = void 0 === B ? 5 : B,
        D = p.paint,
        E = void 0 === D ? {} : D,
        F = b.paint,
        G = void 0 === F ? {} : F,
        H = b.layout,
        I = void 0 === H ? {} : H,
        J = (0, c.default)(b, ["id", "source", "source-layer", "cluster", "paint", "layout"]),
        K = "".concat(b.id, "-").concat(g, "-").concat(f),
        L = J.filter;
    a.addSource(K, {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: []
      },
      cluster: !0,
      clusterMaxZoom: r,
      clusterRadius: d,
      maxzoom: r,
      filter: L // filter on the source enable cluster filtering

    });
    var M = e({}, E, {
      "circle-radius": j(s, t),
      "circle-color": j(s, u),
      "circle-stroke-width": C,
      "circle-stroke-opacity": .4,
      "circle-stroke-color": j(s, u)
    });
    /**
    * The clustered layer
    */

    /**
    * The no-clustered layer
    */

    /**
    * The count layer
    */

    a.addLayer(e({}, J, {
      id: "".concat(m, "-").concat(f),
      type: "circle",
      source: K,
      filter: ["has", "point_count"],
      paint: e({}, M),
      minzoom: k,
      maxzoom: l
    })), a.addLayer(e({
      type: "circle"
    }, J, {
      id: "".concat(m, "-").concat(h, "-").concat(f),
      source: K,
      filter: ["!", ["has", "point_count"]],
      paint: e({}, G),
      layout: e({}, I),
      minzoom: k,
      maxzoom: l
    })), a.addLayer(e({}, J, {
      id: "".concat(m, "-").concat(i, "-").concat(f),
      type: "symbol",
      source: K,
      filter: ["has", "point_count"],
      layout: {
        "text-field": "{point_count_abbreviated}",
        "text-font": y,
        "text-size": j(s, t),
        "text-allow-overlap": !0
      },
      paint: {
        "text-color": A
      },
      minzoom: k,
      maxzoom: l
    }));
  };

  a.createClusterLayers = k;

  var l = function l(a, b) {
    var d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (_ref2) {
      var a = _ref2.features;
      return a;
    };
    var f = b.id,
        h = b.source,
        i = b["source-layer"],
        j = b.minzoom,
        l = void 0 === j ? 0 : j,
        m = b.maxzoom,
        n = void 0 === m ? 24 : m,
        o = b.cluster.radius,
        p = (0, c.default)(b, ["id", "source", "source-layer", "minzoom", "maxzoom", "cluster"]),
        q = "".concat(f, "-cluster-data");
    a.getLayer(q) || a.addLayer({
      id: "".concat(f, "-cluster-data"),
      type: "circle",
      source: h,
      "source-layer": i,
      minzoom: l,
      maxzoom: n,
      paint: {
        "circle-color": "transparent"
      }
    });
    var r = a.getZoom(),
        s = (Array.isArray(o) ? _toConsumableArray(o) : [{
      value: o
    }]).map(function (_ref3, h) {
      var c = _ref3.value,
          _ref3$minzoom = _ref3.minzoom,
          d = _ref3$minzoom === void 0 ? l : _ref3$minzoom,
          _ref3$maxzoom = _ref3.maxzoom,
          e = _ref3$maxzoom === void 0 ? n : _ref3$maxzoom;
      var i = "".concat(f, "-").concat(g, "-").concat(h);
      return a.getSource(i) || k({
        map: a,
        layer: b,
        radius: c,
        minzoom: d,
        maxzoom: e,
        index: h
      }), i;
    });
    if (l > r || n < r) return;
    var t = Array.from(a.querySourceFeatures(h, {
      sourceLayer: i
    }).reduce(function (a, b) {
      var c = b.properties._id;
      return a.set(c, b), a;
    }, new Map()).values()),
        u = d(e({
      layer: f,

      /* mapobx layer id */
      features: t,
      source: h,
      sourceLayer: i
    }, p));
    s.forEach(function (b) {
      a.getSource(b).setData({
        type: "FeatureCollection",
        features: u
      });
    });
  };

  a.updateCluster = l;

  var m = function m(a) {
    var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise(function (c) {
      var d = b.source,
          e = b.properties,
          f = void 0 === e ? {} : e,
          g = f.cluster,
          h = f.cluster_id;
      g ? a.getSource(d).getClusterLeaves(h, -1, 0, function (a) {
        var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return c(b);
      }) : c(null);
    });
  };

  a.getClusteredFeatures = m;
  a.default = {
    updateCluster: l,
    getClusteredFeatures: m
  };
});